import { Helper } from '../../../utils/helper';
import { CHAT_UI_PALETTE } from '../chat/chatUiTheme';

const helper = new Helper();

export const apiBase = helper.getBaseUrl;
export const palette = CHAT_UI_PALETTE;
export const accent = '#DCFF4A';
export const documentListLimit = 10000;
export const sourcePreviewLimit = 6;
export const agentChatPath = '/api/sharepoint/agent/chat/default/thread-placeholder';
